// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.message_right__jfrxt {
  justify-content: flex-end;
}
.message_right__jfrxt .message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ {
  background-color: rgba(95, 143, 223, 0.3);
}

.message_conversationList__Z03Fl {
  display: flex;
  max-width: 70%;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ {
  padding: 8px 12px 4px 12px;
  background-color: #eaedef;
  word-break: break-word;
  white-space: pre-wrap;
  position: relative;
  text-align: start;
  border-radius: 20px;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 8px;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ p {
  margin: 0;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ .message_chatParty__WM33B {
  color: #626d7a;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 0;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ .message_imageAttached__d1ojP {
  display: flex;
  align-self: center;
  justify-content: center;
  object-fit: contain;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ .message_imageAttached__d1ojP img {
  max-height: 190px;
  object-fit: cover;
  width: 100%;
  height: auto;
  display: block; /* Убирает лишние отступы */
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ .message_chatTime__kyGz6 {
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  margin-top: 4px;
  text-align: right;
  color: #626d7a;
}
.message_conversationList__Z03Fl .message_ctextWrapContent__zswU\\+ .message_btnsCtrl__DpTCe {
  width: 300px;
  padding-top: 10px;
  align-items: left;
  text-align: left;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-self: center;
  display: inline-flex;
}

.message_boxFile__M8KFH {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.message_boxFile__M8KFH label {
  max-width: 160px;
  height: fit-content;
  font-size: 0.825rem;
  color: #4a596a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.message_linkFile__lN-Sk {
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  color: #5f8fdf;
  border-radius: 0.5rem;
  background: transparent;
  height: 54px;
  width: 54px;
}
.message_linkFile__lN-Sk:hover {
  background-color: rgba(95, 143, 223, 0.4);
}

.message_video__pC58S {
  max-height: 190px;
  width: 100%;
  height: auto;
}

.message_load__ELq6N {
  height: 190px;
  width: 190px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/DialogList/Rows/message.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,yBAAA;AAAF;AAGI;EACE,yCAAA;AADN;;AAMA;EACE,aAAA;EACA,cAAA;AAHF;AAKE;EACE,0BAAA;EACA,yBCZU;EDaV,sBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,SAAA;AAJN;AAOI;EACE,cCtBW;EDuBX,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AALN;AAQI;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAQM;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EAEA,cAAA,EAAA,2BAAA;AAPR;AAWI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCpDW;AD2CjB;AAYI;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oBAAA;AAVN;;AA2DA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAxDF;AA0DE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cC3Ha;ED4Hb,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxDJ;;AA4DA;EACE,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cC9Ia;ED+Ib,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAzDF;AA2DE;EACE,yCCpJc;AD2FlB;;AA6DA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,YAAA;AA1DF","sourcesContent":["@import '../../../../variables.scss';\n\n.right {\n  justify-content: flex-end;\n\n  .conversationList {\n    .ctextWrapContent {\n      background-color: rgba($active-color, 0.3);\n    }\n  }\n}\n\n.conversationList {\n  display: flex;\n  max-width: 70%;\n\n  .ctextWrapContent {\n    padding: 8px 12px 4px 12px;\n    background-color: $gray-active;\n    word-break: break-word;\n    white-space: pre-wrap;\n    //color: $white;\n    position: relative;\n    text-align: start;\n    border-radius: 20px;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 22px;\n    margin-bottom: 8px;\n\n    p {\n      margin: 0;\n    }\n\n    .chatParty {\n      color: $text-color-700;\n      text-align: left;\n      font-size: 13px;\n      font-weight: 500;\n      line-height: 22px;\n      margin-bottom: 0;\n    }\n\n    .imageAttached {\n      display: flex;\n      align-self: center;\n      justify-content: center;\n      object-fit: contain;\n\n      img {\n        max-height: 190px;\n        object-fit: cover;\n        width: 100%;\n        height: auto;\n        // width: auto; /* Автоматически подбирает ширину, сохраняя пропорции */\n        display: block; /* Убирает лишние отступы */\n      }\n    }\n\n    .chatTime {\n      font-size: 12px;\n      line-height: 15px;\n      font-weight: 500;\n      margin-top: 4px;\n      text-align: right;\n      color: $text-color-700;\n    }\n\n    .btnsCtrl {\n      width: 300px;\n      padding-top: 10px;\n      align-items: left;\n      text-align: left;\n      align-items: center;\n      align-content: center;\n      justify-content: center;\n      justify-self: center;\n      display: inline-flex;\n    }\n  }\n\n  // .dropdown {\n  //   .dropdown-toggle {\n  //     font-size: 18px;\n  //     padding: 4px;\n  //     color: gray;\n\n  //     @media (max-width: 575.98px) {\n  //       display: none;\n  //     }\n  //   }\n  // }\n\n  // .message-img {\n  //   border-radius: 0.2rem;\n  //   position: relative;\n\n  //   .message-img-list {\n  //     position: relative;\n  //   }\n\n  //   img {\n  //     max-width: 150px;\n  //   }\n\n  //   .message-img-link {\n  //     position: absolute;\n  //     right: 10px /*rtl:auto*/;\n  //     left: auto /*rtl:0*/;\n  //     bottom: 10px;\n\n  //     li {\n  //       > a {\n  //         font-size: 18px;\n  //         color: white;\n  //         display: inline-block;\n  //         line-height: 30px;\n  //         width: 30px;\n  //         height: 30px;\n  //         text-align: center;\n  //       }\n  //     }\n  //   }\n  // }\n}\n\n.boxFile {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n\n  label {\n    max-width: 160px;\n    height: fit-content;\n    font-size: 0.825rem;\n    color: $text-color-800;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.linkFile {\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.3rem;\n  color: $active-color;\n  border-radius: 0.5rem;\n  background: transparent;\n  height: 54px;\n  width: 54px;\n\n  &:hover {\n    background-color: $active-color-op;\n  }\n}\n\n.video {\n  max-height: 190px;\n  width: 100%;\n  height: auto;\n}\n\n.load {\n  height: 190px;\n  width: 190px;\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"right": `message_right__jfrxt`,
	"conversationList": `message_conversationList__Z03Fl`,
	"ctextWrapContent": `message_ctextWrapContent__zswU+`,
	"chatParty": `message_chatParty__WM33B`,
	"imageAttached": `message_imageAttached__d1ojP`,
	"chatTime": `message_chatTime__kyGz6`,
	"btnsCtrl": `message_btnsCtrl__DpTCe`,
	"boxFile": `message_boxFile__M8KFH`,
	"linkFile": `message_linkFile__lN-Sk`,
	"video": `message_video__pC58S`,
	"load": `message_load__ELq6N`
};
export default ___CSS_LOADER_EXPORT___;
